module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navbar', {
    attrs: {
      "back": "",
      "fixed": ""
    }
  }, [_c('span', {
    slot: "title"
  }, [_vm._v("关注微信")])]), _vm._v(" "), _c('div', {
    staticClass: "page-content"
  }, [_c('scroller', {
    ref: "scroller"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "wechat-img",
    attrs: {
      "src": require("./wechat.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "txt"
  }, [_c('p', [_vm._v("多种产品快速申请通道")]), _vm._v(" "), _c('p', [_vm._v("在线客服的及时帮助")]), _vm._v(" "), _c('p', [_vm._v("为您带来专业的贷款咨询和便捷服务")])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-efcfa1c8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discover/follow.vue
// module id = 381
// module chunks = 1